import React, { useState } from "react";
import { Link } from "react-router-dom";
import { iconsDocs } from "../../services/icones-fichiers";
import { FaLink } from "react-icons/fa6";
import { normalizeFileContenu } from "../../services/normalizeContenu";

export default function Navigation({
  myClassName,
  linksNavigates,
  details,
  allMessages,
}) {
  const [index, setIndex] = useState(null);
  const [view, setView] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [images, setImages] = useState([]);
  const [liens, setLiens] = useState([]);

  const toggleNavigate = (idx) => {
    if (idx === index) {
      setIndex(null);
      setView(null);
    } else {
      setIndex(idx);
    }
    if (idx === 0) {
      setView("Images");
      const imageFormats = ["jpeg", "jpg", "png", "gif", "bmp", "webp", "tiff", "svg"];
      const imgItems = allMessages
        .filter((sms) => sms.nature === "fichier")
        .flatMap((sms) => normalizeFileContenu(sms.contenu))
        .filter((item) => imageFormats.includes(item.format?.toLowerCase()));
      setImages(imgItems);
    } else if (idx === 1) {
      setView("Documents");
      const imageFormats = ["jpeg", "jpg", "png", "gif", "bmp", "webp", "tiff", "svg"];
      const docItems = allMessages
        .filter((sms) => sms.nature === "fichier")
        .flatMap((sms) => normalizeFileContenu(sms.contenu))
        .filter((item) => !imageFormats.includes(item.format?.toLowerCase()));
      setDocuments(docItems);
    } else {
      setView("Liens");
      const liens = allMessages.filter((lien) => lien.nature === "lien");
      const result = liens.flatMap((item) => item.contenu.slice(0, -1));
      setLiens(result);
    }
  };

  return (
    <>
      <div className={`tyn-aside-row ${myClassName}`}>
        <ul className="nav nav-tabs nav-tabs-line">
          {linksNavigates.map((link, idx) => (
            <li className="nav-item" key={idx}>
              <button
                className={`nav-link ${idx === index ? "active" : ""}`}
                data-bs-toggle="tab"
                data-bs-target="#chat-media-images"
                type="button"
                onClick={() => {
                  details
                    ? toggleNavigate(idx)
                    : alert("Cette navigation n'est pas encore fonctionnelle.");
                }}
              >
                {link}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {details ? (
        <div className="tyn-aside-row">
          <div className="tab-content">
            <div
              className={`tab-pane ${
                view === "Images"
                  ? "show active animate__flipInY animate__animated"
                  : ""
              }`}
              id="chat-media-images"
              tabIndex="0"
            >
              <div className="row g-3">
                {images.map((img, idx) => (
                  <div className="col-4" key={idx}>
                    <img
                      src={img.fileUrl}
                      className="tyn-image"
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </div>

            <div
              className={`tab-pane ${
                view === "Documents"
                  ? "show active animate__flipInY animate__animated"
                  : ""
              }`}
              id="chat-media-files"
              tabIndex="0"
            >
              <ul className="tyn-media-list gap gap-3">
                {documents.map((doc, idx) => (
                  <li key={idx}>
                    <Link
                      to={doc.fileUrl}
                      target="_blank"
                      className="tyn-file"
                    >
                      <div className="tyn-media-group">
                        <div className="tyn-media tyn-size-lg text-bg-light">
                          {(iconsDocs.find(
                            (ext) =>
                              ext.extension.toLowerCase() ===
                              doc.format?.toLowerCase()
                          ) || iconsDocs[iconsDocs.length - 1]).icon}
                        </div>
                        <div className="tyn-media-col">
                          <h6 className="name">{doc.nom}</h6>
                          <div className="meta">{doc.taille}</div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div
              className={`tab-pane ${
                view === "Liens"
                  ? "show active animate__flipInY animate__animated"
                  : ""
              }`}
              id="chat-media-links"
              tabIndex="0"
            >
              <ul className="tyn-media-list gap gap-3">
                {liens.map((lien, idx) => (
                  <li key={idx}>
                    <Link to={lien.href} target="_blank" className="tyn-links">
                      <div className="tyn-media-group">
                        <div className="tyn-media tyn-size-xl">
                          <FaLink style={{ fontSize: "70px" }} />
                        </div>
                        <div className="tyn-media-col">
                          <h6 className="name">{lien.value}</h6>
                          <div className="anchor">{lien.href}</div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
